import React, { useContext } from 'react';
import { AppConfigContext } from '@providers/AppConfigProvider';
import ErrorImage from '@components/common/ErrorImage';
import { ErrorImageConvertUtility } from '@utils/ErrorImageConvertUtility';

interface ContentImageProps {
  src: {
    original: string;
    xs: string;
    sm: string;
    md: string;
    lg: string;
    xl: string;
    '2xl': string;
  };
  alt: string;
  className: string;
}

export default function ContentImage({ src, alt, className = '' }: ContentImageProps): JSX.Element {
  const { isMobile } = useContext(AppConfigContext);
  let newSrc = src.md;
  let imageWidth = '350';
  let imageHeight = '262';
  if (isMobile) {
    newSrc = src.sm;
    imageWidth = '100';
    imageHeight = '75';
  }

  return (
    <picture>
      <source srcSet={newSrc} />
      <ErrorImage
        alt={alt}
        className={`${className} w-full h-full rounded-3xl max-md:rounded-md`}
        width={imageWidth}
        height={imageHeight}
        onError={(event: React.SyntheticEvent<HTMLImageElement>) => {
          ErrorImageConvertUtility.convertErrorImage(event.currentTarget);
        }}
      />
    </picture>
  );
}
